export default "__VITE_ASSET__DbRNB9Km__"